import React, { useState, useEffect } from "react";
import "./CancelAppointment.css";
import {
  GetAppointment,
  // GetServices,
  // GetBarbers,
  CancelAppointmentCall,
  // GetShopId
} from "./Requests";
import { DateTime } from "luxon";
import { PulseLoader } from "react-spinners";
import { useTranslation } from "react-i18next";

const CancelAppointment = () => {
  const { t, i18n } = useTranslation("cancelAppointment");

  const queryParameters = new URLSearchParams(window.location.search);
  const appointmentIdFromUrlParam = queryParameters.get("appointment");

  const [appointmentId] = useState(appointmentIdFromUrlParam);
  const [appointment, setAppointment] = useState();
  const [isLoading, setIsLoading] = useState(true);
  const [appointmentFound, setAppointmentFound] = useState(false);
  // const [barberName, setBarberName] = useState();
  // const [serviceName, setServiceName] = useState();
  const [date, setDate] = useState();
  // const [time, setTime] = useState();
  const [cancelledClicked, setCancelledClicked] = useState(false);
  const [shopId, setShopId] = useState();
  const [cancelledSuccessful, setCancelledSuccessful] = useState();

  useEffect(() => {
    GetAppointmentWrapper();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function GetAppointmentWrapper() {
    GetAppointment(appointmentId)
      .then((res) => {
        i18n.changeLanguage(res.data.emailLanguage);
        if (res.data.appointment !== "") {
          setAppointment(res.data.appointment);
          setDate(
            new Date(
              DateTime.fromISO(res.data.appointment.startDateTime, { zone: "utc" })
                .setZone(res.data.timeZone)
                .toString()
                .split("+")[0]
            )
          );
          // GetBarbersWrapper(res.data)
          setShopId(res.data.appointment.shopId);
          setIsLoading(false);
          setAppointmentFound(true);
        } else {
          setAppointmentFound(false);
          setIsLoading(false);
        }
      })
      .catch(() => {
        setAppointmentFound(false);
        setIsLoading(false);
      });
  }

  // function GetBarbersWrapper(appointmentVar) {}
  // function GetServicesWrapper(appointmentVar) {}

  function CancelButtonClicked() {
    setCancelledClicked(true);
    setIsLoading(true);
    setAppointmentFound(false);
    CancelAppointmentCall(appointment.eventId, 0, "Customer", shopId)
      .then((res) => {
        if (res.status === 200) {
          setIsLoading(false);
          setCancelledSuccessful(true);
        }
      })
      .catch(() => {
        setIsLoading(false);
        setCancelledSuccessful(false);
      });
  }

  const formattedDate = date ? new Date(date).toLocaleDateString() : "";
  const formattedTime = date ? new Date(date).toLocaleTimeString() : "";

  return (
    <div className="login-background">
      <div className="login-container">
        <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
          <div>
            <PulseLoader
              color={"#333"}
              loading={isLoading}
              size={25}
              aria-label={t("cancel.misc.loading")}
              data-testid="loader"
            />
          </div>
        </div>

        {!isLoading && !cancelledClicked ? (
          appointmentFound ? (
            <div className="cancel-apt-container">
              <h1 className="login-title">{t("cancel.titles.cancelAppointment")}</h1>
              <p className="login-subtitle">
                {t("cancel.subtitles.aboutToCancel", {
                  date: formattedDate,
                  time: formattedTime,
                })}
              </p>
              <p className="login-subtitle">{t("cancel.subtitles.confirmQuestion")}</p>
              <button className="cancel-apt-button" onClick={CancelButtonClicked}>
                {t("cancel.actions.yesCancel")}
              </button>
            </div>
          ) : (
            <div className="cancel-apt-container">
              <h1 className="login-title">{t("cancel.titles.ohNo")}</h1>
              <p className="login-subtitle">{t("cancel.subtitles.notFound")}</p>
            </div>
          )
        ) : null}

        {!isLoading && cancelledClicked && cancelledSuccessful ? (
          <div className="cancel-apt-container">
            <div className="icon-wrapper">
              <span className="check-icon">&#10003;</span>
            </div>
            <h1 className="login-title">{t("cancel.titles.appointmentCancelled")}</h1>
            <p className="login-subtitle">{t("cancel.subtitles.cancelledMessage")}</p>
            <a
              style={{ marginLeft: "auto", marginRight: "auto" }}
              href={process.env.REACT_APP_CLIENT_BASE_URL + "make-a-booking?id=" + shopId}
            >
              <button className="cancel-apt-button">
                {t("cancel.actions.bookAnother")}
              </button>
            </a>
          </div>
        ) : null}

        {!isLoading && cancelledClicked && !cancelledSuccessful ? (
          <div className="cancel-apt-container">
            <div className="icon-problem-wrapper">
              <span className="problem-icon">&#x2718;</span>
            </div>
            <h1 className="login-title">{t("cancel.titles.problem")}</h1>
            <p className="login-subtitle">{t("cancel.subtitles.problemMessage")}</p>
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default CancelAppointment;
